






import {
  Component,
  Emit,
  Inject,
  Model,
  Prop,
  Provide,
  Vue,
  Watch
} from "vue-property-decorator";
import { State, Getter, Action, Mutation, namespace } from "vuex-class";
import { swiper } from "vue-awesome-swiper";
import * as types from "@/store/constants/types";
import EventBus from "@/utils/eventBus";
@Component({
  components: {
    swiper
  }
})
export default class Swiper extends Vue {
  @Prop({
    default: 0
  })
  private tabsArractiveIndex?: number;

  @Prop({ default: false })
  private noInit?: boolean;

  private tabsArrIndex: number = 0;

  get swiperOption() {
    return {
      // some swiper options/callbacks
      // 所有的参数同 swiper 官方 api 参数
      // ...
      autoplay: false,
      preloadImages: false,
      updateOnImagesReady: false,
      // autoHeight: true,
      on: {
        slideChangeTransitionStart: () => {
          const ref: any = this.$refs;
          if (ref.tabref && ref.tabref.swiper) {
            console.log("this.tabsArrIndex", ref.tabref.swiper.activeIndex);
            this.$emit("slideChange", ref.tabref.swiper.activeIndex);
          }
        }
      }
    };
  }

  @Watch("tabsArractiveIndex")
  private changeTab(val: any, oldVal: any) {
    console.log("changeTab:", {
      val,
      oldVal
    });
    const ref: any = this.$refs;
    ref.tabref &&
      ref.tabref.swiper.slideTo(this.tabsArractiveIndex, 300, false);
  }
}
